export const optimizeGTMUrl = String(process.env.REACT_APP_OPTIMIZE_GTM_URL);
